module.exports = __webpack_public_path__ + "static/product-placeholder-5070bcab0952bf1a8fc829dfa25a5261.jpg";